import * as React from "react";
import Component from "../../AbstractComponent";
import Button from '@material-ui/core/Button';
import TextField from "../Material/TextField";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import UnitLookup from "../../Partials/Lookup/UnitLookup";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Constants from "../../../Action/Constants";
import MenuItem from '@material-ui/core/MenuItem';
import Select from "../Material/Select";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
// import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import PersonFactory from "../../../Entity/Factories/PersonFactory";
import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import * as uuidV4 from "uuid/v4";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachNewContractDialog extends Component {
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachCreateNewContact: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    selectedUnit: null,
    amazonFolderName: uuidV4(),
    firstName: "",
    tenantChoice: "newtenant",
    lastName: "",
    tenantType: "person",
    tenant: null,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,
    isSaving: false,
    isClosePreprocessDialogOpen: false,

    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("label-occupant"),
    occupantError: null,
    occupantsData: [],
    showAdditionalSection: false,

    //Contract data
    contract: null,
    finalRentalPeriodDate: null,
    expirationDate: null,
    // expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
    lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
    status: this.props.app.contractStatuses['CONCEPT'],
    note: "",
    firstDate: Time.firstDateNextMonth(),

    //Charge template data
    amount: "",
    isPaidDirectlyToOwner: false,
    isDefault: !!this.props.shouldCreateDefault,
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
    description: "",
    paymentOffset: FirstDayOfPeriod.value,
    type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Basic_rent"),
    dueDateFirstPayment: Time.firstDateNextMonth(),
    dueDateFirstPaymentWasManuallyChanged: false,
    endDate: this.props.endDate ? this.props.endDate : null,
    isCreateChargeTypePopupOpen: false,
    isCollective: true,
    chargeTemplates: [],
    errorAmountTemplate: false,

    isCommercial: false,
    autoSendInvoiceToTenant: false,
    addressForRentEmail: ""
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    if (this.props.unitCreateByCoach || this.props.unitCreatedByAgencyCoachScenario) {
      this.setState({
        selectedUnit: this.props.unitCreateByCoach || this.props.unitCreatedByAgencyCoachScenario,
      });
    }

    if (this.props.activeStep) {
      this.setState({
        activeStep: this.props.activeStep
      })
    }

    if (this.props.selectedUnit) {
      let chargeTemplates = [];
      this.props.selectedUnit?.defaultChargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => {
          return !!chargeTemplate;
        })
        .forEach(template => {
          let chargeTemplate = {
            amount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
            currency: template?.currency?.getCurrencyId(),
            type: template?.type?.id,
            repeatPeriod: template?.repeatPeriod?.id,
            description: template?.description,
            paymentOffset: template?.paymentOffset?.getValue(),
            dueDateFirstPayment: Time.firstDateNextMonth(),
            firstDate: Time.firstDateNextMonth(),
            endDate: null,
            isDefault: false,
            oldAmount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
            isDummyPay: template?.isDummyPay,
            contactId: template?.contactId,
            companyId: template?.companyId,
            isCollective: template?.isCollective,
            id: template?.id,
            percentage: "0",
            editedAmount: parseFloat(Formatter.simpleFormatNumber(template.amount)),
            buttonDisabled: true,
            isPaidDirectlyToOwner: template?.isPaidDirectlyToOwner
          }

          chargeTemplates.push(chargeTemplate);
        });


      const type = chargeTemplates.find(template => template.type === TypeContainer.pickIdFromLabel("Basic_rent"))
        ? TypeContainer.pickIdFromLabel("Other_receivable")
        : TypeContainer.pickIdFromLabel("Basic_rent")

      this.setState({
        selectedUnit: this.props.selectedUnit,
        chargeTemplates: [...chargeTemplates],
        isPaidDirectlyToOwner: chargeTemplates.length && chargeTemplates.every(template => template.isPaidDirectlyToOwner),
        type,
      })
    }

    this.setState({
      openCoachCreateNewContact: this.props.openCoachCreateNewContact,
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachCreateNewContact: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedUnit: null,
      amazonFolderName: uuidV4(),
      firstName: "",
      tenantChoice: "newtenant",
      lastName: "",
      tenantType: "person",
      tenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      companyTenant: null,
      isSaving: false,
      isClosePreprocessDialogOpen: false,

      //Occupant data
      occupantFirstName: "",
      occupantLastName: "",
      occupantDescription: this.trans("label-occupant"),
      occupantError: null,
      occupantsData: [],
      showAdditionalSection: false,

      //Contract data
      contract: null,
      finalRentalPeriodDate: null,
      expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
      lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
      status: this.props.app.contractStatuses['CONCEPT'],
      note: "",
      firstDate: Time.firstDateNextMonth(),

      //Charge template data
      amount: "",
      isPaidDirectlyToOwner: false,
      isDefault: !!this.props.shouldCreateDefault,
      currency: this.props.app.settings.user.currency.getCurrencyId(),
      repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      description: "",
      paymentOffset: FirstDayOfPeriod.value,
      type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Basic_rent"),
      dueDateFirstPayment: Time.firstDateNextMonth(),
      dueDateFirstPaymentWasManuallyChanged: false,
      endDate: this.props.endDate ? this.props.endDate : null,
      isCreateChargeTypePopupOpen: false,
      isCollective: true,
      chargeTemplates: [],
      errorAmountTemplate: false,

      isCommercial: false,
      autoSendInvoiceToTenant: false,
      addressForRentEmail: ""
    });
  }

  public onCloseContractCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => { this.clearState() }, 100);

    if (this.props.onCloseContractCoach) {
      this.props.onCloseContractCoach.call(this, this.state?.contract);
    }
  }

  /* Logic for open other coaches */
  public openUnitCoachDialog = () => {
    if (this.props.openUnitCoachDialog) {
      this.props.openUnitCoachDialog.call(this);
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("coach/newcontract-step/first-step-title"),
      this.trans("coach/newcontract-step/second-step-title"),
      this.trans("coach/newcontract-step/third-step-title"),
      this.trans("coach/newcontract-step/fourth-step-title"),
      this.trans("coach/newcontract-step/fifth-step-title"),
      this.trans("coach/newcontract-step/sixth-step-title")
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      case 4:
        return this.stepContent(step);
      case 5:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
        {step === 4 && this.fifthStepDetails()}
        {step === 5 && this.sixthStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newcontract-step/first-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newcontract-step/first-subtitle")}
        />
        <div>
          <UnitLookup
            {...this.props}
            id="unitId"
            name="unitId"
            ref="UnitLookup"
            className="scroll-to-unitId"
            additionalClasses="unit-lookup-component"
            floatingLabelText={this.trans("dropdown-searchforunit-label")}
            styleInModal={"styleInModal"}
            autoSelectId={this.state.selectedUnit?.id}
            onSelect={this.selectUnit}
            onClear={this.clearUnit}
            fullUnitName={true}
            autoFocus={true}
            disabled={!!this.props.unitCreatedByAgencyCoachScenario}
            saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect}
            width="100%"
            containerWidth="100%"
            hideClickThroughLink={true}
            disableEntityCreation={true}
          />
        </div>
      </div>
    )
  }

  public secondStepSummary = () => {
    let summaryArr = [];

    if (this.state.tenantType === "company") {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newcompany-label"),
        value: this.state.companyTenant?.name
      })
    }

    summaryArr.push({
      label: this.trans("coach/propertyowner-field/newperson-label"),
      value: this.state.tenant?.displayName
    })

    return summaryArr;
  }

  public secondStepDetails = () => {
    if ((this.state.tenant || this.state.companyTenant) && this.state.tenantChoice === "newtenant") {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newcontract-step/second-title")}
          />
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", { entity: this.trans("title-tenant").toLowerCase() })}
          />
          <CoachSummaryTable
            tableRows={this.secondStepSummary()}
          />
        </div>
      );
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newcontract-step/second-title")}
          />
          <Subtitle
            subtitle={this.trans("coach/newcontract-step/second-subtitle")}
          />
          {
            <RadioGroup
              name="chargeOwnerChoice"
              className="filters-container"
              value={this.state.tenantChoice}
              onChange={this.changeTenantChoice}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                marginBottom: "15px"
              }}
            >
              <FormControlLabel
                control={<Radio color="primary" />}
                value="newtenant"
                label={this.trans("coach/newcontract-step/first-newtenant/label")}
                style={{ width: "auto", fontSize: "16px" }}
              />

              <FormControlLabel
                control={<Radio color="primary" />}
                value="existingtenant"
                label={this.trans("coach/newcontract-step/first-existingtenant/label")}
                style={{ width: "auto", fontSize: "16px" }}
              />
            </RadioGroup>
          }

          {this.state.tenantChoice === "existingtenant" ?
            <div className="search-bar-container">
              <Searchbar
                {...this.props}
                name="personId"
                className="scroll-to-mainTenantContactId"
                id="selectedTenantForContract"
                ref="TenantLookup"
                floatingLabelText={this.trans("label-tenant")}
                allResults={true}
                objectField={true}
                onChange={this.selectTenant}
                onClear={this.clearTenant}
                selectedEntity={this.state.tenant}
                searchParameter={"contactsSearch"}
                error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                searchText={this.state.tenant ? `${this.state.tenant?.nameOfEntity}, ${this.state.tenant?.displayName}` : null}
                styleInModal={"pick-object-modal"}
              />
            </div>
            :
            <div>
              <div>
                {this.trans("coach/propertyowner-scenario/tenant-step/first-choosetype")}
              </div>
              <RadioGroup
                className="filters-container"
                value={this.state.tenantType}
                onChange={this.chooseTenantType}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  width: "500px",
                  paddingLeft: "0px"
                }}
              >
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="person"
                  label={this.trans("coach/propertyowner-radiobutton/person")}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="company"
                  label={this.trans("coach/propertyowner-radiobutton/company")}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
              </RadioGroup>
              {this.state.tenantType === "person" &&
                <div>
                  <p className="info-text">
                    {this.trans("coach/newpropertyfirstuser-step/tenant-info1")}
                  </p>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "600px", marginRight: "20px" }}>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        autoFocus={true}
                        label={this.trans("label-first-name")}
                        value={this.state.tenantFirstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                        variant="standard"
                        error={!!this.getErrorFor("firstName") && !this.state.occupantError}
                      />
                      {(!!this.getErrorFor("firstName") && !this.state.occupantError) && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}
                    </div>
                    <TextField
                      autoComplete="off"
                      // id="lastName"
                      // name="lastName"
                      className="form-element full-size scroll-to-lastName"
                      type="text"
                      label={this.trans("label-last-name") + this.trans("field/optional")}
                      value={this.state.tenantLastName}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                      variant="standard"
                      error={!!this.getErrorFor("lastName")}
                    />
                  </div>
                  <div className="hint-styles">
                    {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                  </div>
                </div>
              }
              {
                this.state.tenantType === "company" &&
                <div>
                  <TextField
                    autoComplete="off"
                    className="form-element full-size"
                    type="text"
                    label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                    value={this.state.companyNameTenant}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
                    variant="standard"
                    autoFocus={true}
                    error={this.getErrorFor("name")}
                  />
                  {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
                  <p style={{ marginTop: "25px" }} className="info-text">
                    {this.trans("coach/newpropertyfirstuser-step/tenant-info3")}
                  </p>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "600px", marginRight: "20px" }}>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        label={this.trans("label-first-name")}
                        value={this.state.tenantFirstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                        variant="standard"
                        error={!!this.getErrorFor("contacts.firstName")}
                      />
                      {!!this.getErrorFor("contacts.firstName") && <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div>}
                    </div>
                    <TextField
                      autoComplete="off"
                      // id="lastName"
                      // name="lastName"
                      className="form-element full-size scroll-to-lastName"
                      type="text"
                      label={this.trans("label-last-name") + this.trans("field/optional")}
                      value={this.state.tenantLastName}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                      variant="standard"
                      error={!!this.getErrorFor("contacts.lastName")}
                    />
                    {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
                  </div>
                  <div className="hint-styles">
                    {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                  </div>
                </div>
              }

              <div className="coach-new-property-save-button">
                <Button
                  color="primary"
                  onClick={this.createTenant}
                  variant="contained"
                  style={{ textAlign: "right" }}
                >
                  {this.trans("button-save")}
                </Button>
              </div>
            </div>
          }
        </div>
      )
    }
  }

  public thirdStepSummary = () => {
    let summaryArr = [];

    if (this.state.companyTenant) {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newcompany-label"),
        value: `${this.state.companyTenant?.name}, ${this.state.tenant?.displayName}`
      })
    } else {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newperson-label"),
        value: this.state.tenant?.displayName
      })
    }

    return summaryArr;
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newcontract-step/third-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newcontract-step/third-subtitle")}
        />
        <CoachSummaryTable
          tableRows={this.thirdStepSummary()}
          style={{ margin: 0 }}
        />
        {this.renderAdditionalFields()}
      </div>
    )
  }

  public fourthStepDetails = () => {
    return (
      <div className="coach-content-wrapper" style={{ width: "700px", maxWidth: "unset" }}>
        <Title
          title={this.trans("coach/newcontract-step/fourth-title")}
          style={{ textAlign: "start" }}
        />
        {/* <Subtitle
          subtitle={this.trans("coach/newcontract-step/fourth-subtitle")}
        /> */}
        <DatePickerComponent
          {...this.props}
          id="firstDate"
          name="firstDate"
          className="scroll-to-firstDate"
          label={this.trans("first-date") + Time.getDatepickerHint()}
          initialDate={this.state.firstDate}
          onChange={date => this.selectDate(date, "firstDate")}
          clearButton={true}
          additionClasses={"datepicker-error-coach"}
          width="60%"
          error={this.getErrorFor("firstDate")}
        />

        <DatePickerComponent
          {...this.props}
          id="lastDate"
          name="lastDate"
          className="scroll-to-lastDate"
          label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
          initialDate={this.state.lastDate}
          onChange={date => this.selectDate(date, "lastDate")}
          minDate={this.state.firstDate}
          minDatePlusDays={1}
          minDateMessage={this.trans("field/lastfinalenddate-info/error")}
          clearButton={true}
          margin={"7px 0"}
          width="60%"
        />

        <DatePickerComponent
          {...this.props}
          id="finalDate"
          name="finalDate"
          className="scroll-to-finalRentalPeriodDate"
          label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
          initialDate={this.state.finalRentalPeriodDate}
          onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
          minDate={this.state.firstDate}
          minDatePlusDays={1}
          minDateMessage={this.trans("field/lastfinalenddate-info/error")}
          clearButton={true}
          error={this.getErrorFor("finalRentalPeriodDate")}
          margin={"7px 0"}
          width="60%"
        />
        <Title title={this.trans("coach/newpropertyfirstuser-step/cotract-amounts")} style={{ textAlign: "start", marginTop: "30px", marginBottom: "0"}} />
        <div style={{ display: "flex", flexDirection: "column"}}>
          {this.state.chargeTemplates?.length > 0 &&
            <ul style={{ margin: 0, padding: 0 }}>
              {
                this.state.chargeTemplates?.map((chargeTemplate, index) => {
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%"}}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px", width: "100%" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }
                            {/* {`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`} */}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                        </div>
                        <div style={{ width: "100%" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: "4px"  }}>
                            <Select
                              className="form-element full-size form-input scroll-to-type correct-label-position"
                              style={{ minWidth: "200px"}}
                              error={this.getErrorFor("type")}
                              value={chargeTemplate?.type}
                              // onChange={(event) => this.setChargeTemplateType(event, index)}
                              htmlFor="type"
                              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
                              name="type"
                              id="type"
                              disabled={true}
                            >
                              {
                                TypeContainer.getChargeTypesForChargeTemplates("contract").map((type, index) => {
                                  return (
                                    <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                                  );
                                })
                              }
                            </Select>
                            <div className="form-element full-size no-margins" style={{maxWidth: "70px"}}>
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                style={{ minWidth: "70px"}}
                                label={this.trans("label-amount")}
                                value={chargeTemplate?.amount}
                                // onChange={(event) => this.setNewChargeAmount(event, index)}
                                disabled={true}
                                variant="standard"
                                error={false}

                              />
                            </div>

                            <Select
                              className="form-element full-size form-input scroll-to-currency correct-label-position"
                              error={this.getErrorFor("currency")}
                              style={{maxWidth: "90px" }}
                              value={chargeTemplate?.currency}
                              htmlFor="currency"
                              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
                              name="currency"
                              id="currency"
                              disabled={true}
                            >
                              {this.getCurrencySelectboxes()}
                            </Select>

                            <Select
                              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                              style={{ maxWidth: "150px" }}
                              error={this.getErrorFor("repeat-period")}
                              value={chargeTemplate?.repeatPeriod}
                              // onChange={(event) => this.setChargeTemplateRepeatPeriod(event, index)}
                              htmlFor="repeatPeriod"
                              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                              name="repeatPeriod"
                              id="repeatPeriod"
                              disabled={true}
                            >
                              {this.getRepeatPeriodSelectboxes()}
                            </Select>
                            <Button
                              color="primary"
                              onClick={() => { this.onClear(index) }}
                              variant="outlined"
                              style={{ marginLeft: "10px", minWidth: "100px" }}
                            >
                              {this.trans("button-remove")}
                            </Button>
                          </div>
                        </div>
                      </div>

                    </>
                  )
                })
              }
            </ul>
          }
        </div>
        <div>

          <div style={{ display: "flex", justifyContent: "space-between", gap: "4px", alignItems: "baseline", width: "100%" }}>
            <Select
              className="form-element full-size form-input scroll-to-type correct-label-position"
              style={{ minWidth: "200px"}}
              error={this.getErrorFor("type")}
              value={this.state.type}
              onChange={(e) => this.setChargeTemplateType(e.target.value)}
              htmlFor="type"
              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
              name="type"
              id="type"
            >
              {
                TypeContainer.getChargeTypesForChargeTemplates("contract")?.filter(chargeType => {
                  if (!!this.state.type && chargeType.removed && (chargeType.id === this.state.type)) {
                    return true;
                  }
                  if (chargeType.removed) {
                    return false;
                  }
                  return true;
                })
                  .map((type, index) => {
                    return (
                      <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
              }
            </Select>
            <div className="form-element full-size no-margins" style={{maxWidth: "70px"}}>
              <TextField
                autoComplete="off"
                // id="amount"
                // name="amount"
                className="form-element full-size scroll-to-amount"
                type="text"
                label={this.trans("dialog/defaultchargetemplates-field/amount-label")}
                value={this.state.amount}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "amount")}
                autoFocus={true}
                variant="standard"
                style={{ minWidth: "70px"}}
                error={this.state.errorAmountTemplate}

              />
              {this.state.errorAmountTemplate && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
            </div>

            <Select
              className="form-element full-size form-input scroll-to-currency correct-label-position"
              style={{ margin: "0 4px", maxWidth: "90px" }}
              error={this.getErrorFor("currency")}
              value={this.state.currency}
              onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
              htmlFor="currency"
              label={this.trans("dialog/agencyfee-field/currency-label")}
              name="currency"
              id="currency"
              disabled={true}
            >
              {this.getCurrencySelectboxes()}
            </Select>

            <Select
              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
              style={{ maxWidth: "150px" }}
              error={this.getErrorFor("repeat-period")}
              value={this.state.repeatPeriod}
              onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
              htmlFor="repeatPeriod"
              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
              name="repeatPeriod"
              id="repeatPeriod"
            >
              {this.getRepeatPeriodSelectboxes()}
            </Select>
            <Button
              color="primary"
              onClick={this.addChargeTemplate}
              variant="contained"
              style={{ marginLeft: "10px", minWidth: "100px" }}
            >
              {this.trans("button-save")}
            </Button>
          </div>
          <div style={{marginTop: "30px"}}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.isPaidDirectlyToOwner}
                onChange={this.switchIsPaidDirectlyToOwner}
                color="primary"
              />
            }
            label={this.trans("coach/newcontract-step/paiddirectlytoowner-label")}
          />

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.isCommercial}
                  onChange={this.changeIsCommercial}
                  color="primary"
                />
              }
              label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
            />
          </div>

          
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.autoSendInvoiceToTenant}
                  onChange={this.changeAutoSendInvoiceToTenant}
                  color="primary"
                />
              }
              label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
            />
          </div>

        </div>
      </div>
    );
  }

  public fifthStepSummary = () => {
    let summaryArr = [];

    if (this.state.selectedUnit) {
      summaryArr.push({
        label: this.trans("title-unit"),
        value: this.state.selectedUnit?.displayName
      })
    }

    if (this.state.chargeTemplates?.length > 0) {
      const monthlyAmount = this.state.chargeTemplates
        .filter(chargeTemplate => chargeTemplate.repeatPeriod === PeriodContainer.pickIdFromLabel("monthly"))
        .reduce((acc, chargeTemplate) => acc + chargeTemplate.amount, 0);
        const monthlyAmountFormatted = this.formatter.formatNumber(monthlyAmount * 100, CurrencyContainer.pickFromId(this.state.chargeTemplates[0].currency));
      this.state?.chargeTemplates?.forEach((chargeTemplate, index) => {
        const type = Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system);
        const amount = this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency));
        if (index === 0) {
          summaryArr.push({
            label: index === 0 ? this.trans("title-contract-prices") : "",
            value: `${monthlyAmountFormatted} ${this.trans("title-monthly")}`
          });
        }
        summaryArr.push({
          label: "",
          value: `${type} ${amount}`
        }
        );
      })
    }

    if (this.state.companyTenant) {
      summaryArr.push({
        label: this.trans("coach/propertyowner-field/newcompany-label"),
        value: `${this.state.companyTenant?.name}, ${this.state.tenant?.displayName}`
      })
    }

    if (this.state.tenant) {
      summaryArr.push({
        label: this.trans("title-tenant"),
        value: this.state.tenant?.displayName
      })
    }

    if (this.state.occupantsData?.length > 0) {
      this.state.occupantsData?.forEach((field, index) => {
        summaryArr.push({
          label: `${this.trans("title-tenant")} ${index + 2}`,
          value: field?.selectedPerson?.displayName
        });
      })
    }

    if (this.state.firstDate) {
      summaryArr.push({
        label: this.trans("coach/increaserent-step/start-date"),
        value: this.formatter.formatDate(this.state.firstDate)
      })
    }

    if (this.state.lastDate) {
      summaryArr.push({
        label: `${this.trans("expiration-date")} 1`,
        value: this.formatter.formatDate(this.state.lastDate)
      })
    }

    if (this.state.finalRentalPeriodDate) {
      summaryArr.push({
        label: `${this.trans("expiration-date")} 2`,
        value: this.formatter.formatDate(this.state.finalRentalPeriodDate)
      })
    }

    return summaryArr;
  }

  public fifthStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newcontract-step/fifth-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-create-subtitle-dutch-het", { entity: this.trans("title-contract").toLowerCase() })}
        />
        <CoachSummaryTable
          tableRows={this.fifthStepSummary()}
        />
      </div>
    )
  }
  public setChargeTemplateType = (type): void => {

    this.setState({
      type: type,
      repeatPeriod: type === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      isCollective: type === TypeContainer.pickIdFromLabel("Deposit")

    })
  }
  public sixthStepDetails = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "fit-content", margin: "0 auto" }}>
        <Title
          title={this.trans("result")}
        />
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          {this.image.getAvatar("success", { size: 62 })}
        </div>
        <Subtitle
          subtitle={this.trans("coach/general-summary-create-subtitle-dutch-het", { entity: this.trans("title-contract").toLowerCase() })}
        />
      </div>
    )
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.contractStartStep1();
  }

  public startStep2 = () => {
    return this.contractStartStep2();
  }

  public startStep3 = () => {
    return this.contractStartStep3();
  }

  public startStep4 = () => {
    return this.contractStartStep4();
  }

  public startStep5 = () => {
    return this.contractStartStep5();
  }

  //Methods for step logic
  public contractStartStep1 = () => {
    this.plusOneStep();
  }

  public contractStartStep2 = () => {
    this.plusOneStep();
  }

  public contractStartStep3 = () => {
    this.plusOneStep();
  }

  public contractStartStep4 = () => {
    this.plusOneStep();
  }

  public contractStartStep5 = () => {
    this.createContract();
  }

  //Methods
  public clearUnit = (): void => {
    this.setState({
      selectedUnit: null
    });
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      tenant: null,
      firstName: ""
    });
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      tenant: entity
    })
  }

  public clearTenant = (): void => {
    this.setState({
      tenant: null
    });
  }

  public clearPerson = (): void => {
    this.setState({
      tenant: null
    });
  }

  public selectPerson = (person: PersonInterface): void => {
    this.setState({
      tenant: person
    });
  }

  public selectUnit = (unit: UnitInterface): void => {
    // Not sure do we need this logic for new implementation
    // when user want to create contract we should copy charge templates from unit
    // let chargeTemplates = [];
    // unit?.defaultChargeTemplates?.forEach(template => {
    //   let chargeTemplate = {
    //     amount: parseFloat(Formatter.simpleFormatNumber(template.amount).replace(",", ".")),
    //     currency: template?.currency.getCurrencyId(),
    //     type: template?.type?.id,
    //     repeatPeriod: template?.repeatPeriod?.id,
    //     description: template?.description,
    //     paymentOffset: template?.paymentOffset?.getValue(),
    //     dueDateFirstPayment: template?.dueDateFirstPayment,
    //     firstDate: template?.firstDate,
    //     endDate: Time.formatOrNull(template.endDate),
    //     isDefault: false,
    //     isPaidDirectlyToOwner: template?.isPaidDirectlyToOwner,
    //     isCollective: template?.isCollective
    //   }
    //   if(template?.type?.id === TypeContainer.pickIdFromLabel("Basic_rent")){
    //     chargeTemplates.push(chargeTemplate);
    //   }
    // });
    this.setState({
      // chargeTemplates: chargeTemplates?.length > 0 ? [chargeTemplates[0]] : [],
      selectedUnit: unit,
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    // Update the state
    this.setState({
      [identifier]: date,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.firstDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.firstDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "firstDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component

        if (this.state.chargeTemplates) {
          this.setState({
            chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
              let chargeTemplateFirstDate = chargeTemplate?.firstDate;
              let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

              if (!!this.state.firstDate && !!chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!this.state.firstDate && !!chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!!this.state.firstDate && !chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!!this.state.firstDate && !!chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              if (!this.state.firstDate && !!chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              if (!!this.state.firstDate && !chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              return {
                ...chargeTemplate,
                firstDate: chargeTemplateFirstDate,
                dueDateFirstPayment: chargeTemplateDueDateFirstPayment
              }
            })
          });
        }

        // we should update last date if it wasn't changed manually
        if (!!this.state.firstDate && !!this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }

        if (!this.state.firstDate && !!this.state.lastDate) {
          return this.selectDate(this.state.firstDate, "lastDate");
        }

        if (!!this.state.firstDate && !this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      if (identifier === "lastDate") {
        if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate) {
          this.selectDate(this.state.lastDate, "finalDate");
        }

        if (!this.state.lastDate && !!this.state.finalRentalPeriodDate) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate) {
          this.selectDate(date, "finalDate");
        }

        // if (!!this.state.lastDate && !!this.state.expirationDate) {
        //   return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        // }

        if (!this.state.lastDate && !!this.state.expirationDate) {
          return this.selectDate(this.state.lastDate, "expirationDate");
        }

        // if (!!this.state.lastDate) {
        //   return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        // }
      }
    });
  }

  public switchIsPaidDirectlyToOwner = () => {
    const chargeTemplates = this.state.chargeTemplates.map(template => {
      template.isPaidDirectlyToOwner = !this.state.isPaidDirectlyToOwner
      return template
    })
    const isPaidDirectlyToOwner = !this.state.isPaidDirectlyToOwner

    this.setState({
      chargeTemplates,
      isPaidDirectlyToOwner,
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }

  public onClear = (index) => {
    const chargeTemplates = this.state.chargeTemplates
    chargeTemplates.splice(index, 1);

    this.setState({
      chargeTemplates: chargeTemplates
    })
  }

  public onClearOccupant = (index) => {
    const occupantsData = this.state.occupantsData
    occupantsData.splice(index, 1);

    this.setState({
      occupantsData: occupantsData
    })
  }


  public getPayloadTenant = (): any => {
    const pageTemplate = "tenant";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName: type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public renderAdditionalFields = (): any => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        {this.state.occupantsData?.length > 0 &&
          <div style={{ marginTop: "15px" }}>
            <div className="info-text">
              {this.trans("coach/newcontract-step/occupantscreated-info1")}
            </div>
            <div>
              {
                this.state.occupantsData?.map((occupant, index) => {
                  return <div style={{ position: "relative" }}> {occupant.error &&
                    <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                      <span
                        className="icon icon-ic-info red"
                      >
                      </span>
                    </span>
                  }
                    <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                      <div style={{ width: "600px", marginRight: "20px" }}>
                        <TextField
                          autoComplete="off"
                          // id="firstName"
                          // name="firstName"
                          className="form-element full-size scroll-to-firstName"
                          type="text"
                          label={this.trans("label-first-name")}
                          value={occupant?.selectedPerson?.firstName}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantFirstName")}
                          variant="standard"
                          error={!!this.state.occupantError}
                          disabled={true}
                        />
                        {!!this.state.occupantError && <div className="component-error-text">{this.trans(this.state.occupantError)}</div>}
                      </div>
                      <TextField
                        autoComplete="off"
                        // id="lastName"
                        // name="lastName"
                        className="form-element full-size scroll-to-lastName"
                        type="text"
                        label={this.trans("label-last-name") + this.trans("field/optional")}
                        value={occupant?.selectedPerson?.lastName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantLastName")}
                        variant="standard"
                        error={!!this.getErrorFor("contacts.lastName")}
                        disabled={true}
                      />

                      <Button
                        color="primary"
                        onClick={() => this.onClearOccupant(index)}
                        variant="outlined"
                        style={{ marginLeft: "20px", minWidth: "max-content", height: "fit-content" }}
                      >
                        {this.trans("button-remove")}
                      </Button>

                    </div>
                  </div>
                })
              }
            </div>
          </div>
        }
        <div style={{ marginTop: "20px" }}>{this.trans("coach/newcontract-step/tenant-infoadditionaloccupant")}</div>
        {this.state.showAdditionalSection &&
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "600px", marginRight: "20px" }}>
              <TextField
                autoComplete="off"
                // id="firstName"
                // name="firstName"
                className="form-element full-size scroll-to-firstName"
                type="text"
                label={this.trans("label-first-name")}
                value={this.state.occupantFirstName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantFirstName")}
                variant="standard"
                error={!!this.state.occupantError}
              />
              {!!this.state.occupantError && <div className="component-error-text">{this.trans(this.state.occupantError)}</div>}
            </div>
            <TextField
              autoComplete="off"
              // id="lastName"
              // name="lastName"
              className="form-element full-size scroll-to-lastName"
              type="text"
              label={this.trans("label-last-name") + this.trans("field/optional")}
              value={this.state.occupantLastName}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantLastName")}
              variant="standard"
              error={!!this.getErrorFor("contacts.lastName")}
            />
            {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
          </div>
        }
        <div className="coach-new-property-add-button">
          <Button
            color="primary"
            onClick={this.state.showAdditionalSection ? this.addNewOccupant : () => { this.setState({ showAdditionalSection: true }) }}
            variant={this.state.showAdditionalSection ? "contained" : "outlined"}
            style={{ textAlign: "right" }}
          >
            {this.state.showAdditionalSection ? this.trans("button-save") : this.trans("coach/newcontract-step/tenant-button/addperson-label")}
          </Button>
        </div>
      </div>
    );
  }

  public createTenant = () => {
    this.setState({
      occupantError: null //need for clear error for occupant fields
    }, () => {
      if (this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                tenant: person
              });
            },
            onError: () => {
              this.setState({
                isSaving: false
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company",
                contacts: this.state.tenantType === "company" ? {
                  ...this.getPayloadForPerson("tenant")
                } : undefined
              }
            },
            onSuccess: (company) => {
              const tenant = PersonFactory.create(company?.data?.contacts?.[0]);

              this.setState({
                companyTenant: company,
                tenant: tenant,
                errorFields: [],
                isSaving: false
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                isSaving: false
              })
            }
          });
        });
      }
    })
  }

  public addChargeTemplate = (): any => {

    if (this.state.amount === "" || !this.state.amount?.trim()?.length || isNaN(+this.state.amount)) {
      return this.setState({
        errorAmountTemplate: true
      });
    }
    const createdChargeTemplate = {
      amount: this.state.amount === "" ? "" : parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amount)).replace(",", ".")).toFixed(2)),
      currency: this.state.currency,
      repeatPeriod: this.state.repeatPeriod,
      description: this.state.description,
      paymentOffset: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? FirstDayOfPeriod.value : this.state.paymentOffset,
      type: this.state.type ? this.state.type
        : this.state.chargeTemplates.find(template => template.type === TypeContainer.pickIdFromLabel("Basic_rent"))
          ? TypeContainer.pickIdFromLabel("Other_receivable")
          : TypeContainer.pickIdFromLabel("Basic_rent"),
      dueDateFirstPayment: this.state.firstDate,
      firstDate: this.state.firstDate,
      endDate: this.state.endDate,
      isDefault: this.state.isDefault,
      isPaidDirectlyToOwner: this.state.isPaidDirectlyToOwner,
      contactId: !this.state.companyTenant ? this.state.tenant?.id : undefined,
      companyId: this.state.companyTenant?.id,
      isCollective: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? false : true,
    }

    const chargeTemplates = [...this.state.chargeTemplates, createdChargeTemplate];

    const reinchargeTemplates = chargeTemplates.map(chargeTemplate => {
      return {
        ...chargeTemplate,
        isPaidDirectlyToOwner: createdChargeTemplate?.isCollective && chargeTemplate?.isCollective ? createdChargeTemplate?.isPaidDirectlyToOwner : chargeTemplate?.isPaidDirectlyToOwner
      }
    })

    this.setState({
      errorAmountTemplate: false,
      chargeTemplates: reinchargeTemplates
    }, () => {
      this.setState({
        amount: "",
        isPaidDirectlyToOwner: this.state.isPaidDirectlyToOwner,
        currency: this.props.app.settings.user.currency.getCurrencyId(),
        repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
        type: this.props.selectedType ? this.props.selectedType : this.state.chargeTemplates.find(template => template.type === TypeContainer.pickIdFromLabel("Basic_rent"))
          ? TypeContainer.pickIdFromLabel("Other_receivable")
          : TypeContainer.pickIdFromLabel("Basic_rent"),
      })
    })
  }

  public createContract = () => {
    const payload: any = {
      сreatedOnFrontend: true,
      unit: this.state.selectedUnit,
      amazonFolderName: this.state.amazonFolderName,
      status: this.state.status,
      firstDate: this.state.firstDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      note: this.state.note,
      chargeTemplates: this.state.chargeTemplates,
      amazonFoldernameTenant: uuidV4(),
      additionalFields: this.state.occupantsData,
      autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
      addressForRentEmail: this.state.addressForRentEmail,
      isCommercial: this.state.isCommercial
    }

    if (this.state.tenant instanceof Company) {
      payload.selectedCompany = this.state.tenant;
    }

    if (this.state.tenant instanceof Person) {
      if (!!this.state.companyTenant) {
        payload.selectedCompany = this.state.companyTenant;
      } else {
        payload.selectedPerson = this.state.tenant;
      }
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_CREATE_START,
        payload: {
          ...payload
        },
        onSuccess: createdContract => {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("you-created-concept-contract"),
              type: "info"
            }
          });

          return this.setState({
            isSaving: false,
            contract: createdContract,
            errorFields: [],
            activeStep: 5
          });
        },
        onError: (err) => {
          const showChargeTemplateErrorDialog = err.fields.some(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          let chargeTemplatesError = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorField;
          if (chargeTemplatesError[0]) {
            chargeTemplatesErrorField = chargeTemplatesError[0].split(".")
          }

          chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          const chargeTemplates = this.state.chargeTemplates.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows.some(field => field === index)
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false
          })

          if (showChargeTemplateErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-chargetemplate-coach", { field: this.trans(`label-${chargeTemplatesErrorField[1]}`) }),
                type: "error"
              }
            });
          } else {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans(err?.errorId),
                type: "error"
              }
            });
          }
        }
      });
    });
  }

  public addNewOccupant = (): any => {
    const occupant = {
      person: {
        firstName: this.state.occupantFirstName,
        lastName: this.state.occupantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: this.trans("label-occupant"),
        pageTemplate: "person",
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: occupant,
        onSuccess: occupant => {
          const occupantObj = {
            selectedPerson: occupant,
            description: occupant?.note,
            contactForContractTypeId: OccupantType.contactForContractTypeId
          }
          const occupantsData = [...this.state.occupantsData, occupantObj];

          this.setState({
            isSaving: false,
            occupantsData: occupantsData,
            occupantError: null
          }, () => {
            this.setState({
              occupantFirstName: "",
              occupantLastName: "",
              occupantDescription: this.trans("label-occupant"),
              showAdditionalSection: false
            })
          });
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            occupantError: err?.errorId
          });
        }
      });
    });
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public changeAutoSendInvoiceToTenant = () => {
    this.setState({
      autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial
    });
  }

  public isNextButtonDisabled = () => {
    if (this.state.activeStep === 0 && !this.state.selectedUnit) {
      return true
    }
    if (this.state.activeStep === 1 && !this.state.tenant) {
      return true
    }
    if (this.state.activeStep === 3 && !this.state.chargeTemplates?.length) {
      return true
    }
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachCreateNewContact}
          onCloseCoach={this.onCloseContractCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={true}
          disabled={false}
          disabledBack={false}
          disabledNext={this.isNextButtonDisabled()}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
